import { createGlobalStyle } from 'styled-components';
import { maxWidth, retina, textTruncateSnippet } from 'Utils/utilsStyle';

const GoogleTranslatorStyle = createGlobalStyle`
  body {
    top: 0px !important;
    > {
      .skiptranslate {
        display: none !important;
      }
    }
  }
  #google_translate_element {
    .google_translate_element, .goog-te-gadget {
      color: transparent !important;
      line-height: 0px;
      span {
        display: none;
      }
    }
  }
  .goog-te-combo{
    cursor: pointer;
    padding: 5px 10px !important;
    margin: 12px 0px 0px 0px !important;
    width: 100% !important;
    border-radius: 3px !important;
    color: #000 !important;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      width: 170px !important;
    }
    option{
      background-color: #fff;
      width: 400px;
    }
    &:focus-visible{
      outline: none;
    }
  }
  .goog-logo-link{
   display: none;
  }
  /* For English Language */
  html[lang="en"]{
    /* global style */
  }
  /* For Chines Language */
  html[lang="zh-CN"], html[lang="zh-TW"]{
    body {
      .sales-sigma{
        width: 37px;
      }
      .ceo-tile {
        .label-name {
          @media all and (max-width: ${maxWidth}), ${retina}{
            font-size: 13px;
          }
        }
      }
      .person-item {
        .person-item-widget {
          .name-wrapper {
            h4 {
              ${textTruncateSnippet}
              max-width: 120px;
            }
          }
        }
      }
      .state{
        ${textTruncateSnippet}
      }
      .chinese-layouticon{
        margin-left: 0px;
      }
      .small-button-chinese {
        min-width: 70px;
      }
      .aside-wrapper {
        .nav-list {
          .item {
            .mt-c-6 {
              ${textTruncateSnippet}
              max-width: 45px;
            }
          }
        }
      }
      .downPrice, .upPrice  {
        .state {
         display: flex;
         margin: 20px auto 0px auto;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            margin: 14px auto 0px auto;
          }
        }
      }
    }
  }
  /* For German Language */
  html[lang="de"]{
    body {
      .article-preview {
        .button-section {
          .article-viewer-btn {
            display: flex;
            align-items: center;
            .tabs-item {
              &:last-child {
                max-width: 100px;
                ${textTruncateSnippet}
              }
            }
          }
        }
      }
      .spotlight-wrapper {
        .state{
          max-width: 150px;
         ${textTruncateSnippet}
        }
      }
      .downPrice, .upPrice  {
        .state {
         display: flex;
         margin: 20px auto 0px auto;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            margin: 14px auto 0px auto;
          }
        }
      }
      .global-filter {
        .heading-panel {
          .head {
            ${textTruncateSnippet}
            max-width: 180px;
          }
        }
        .grid-checkbox-wrapper {
          .title-name {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 90px;
          }
        }
      }
      .drawer-alerts {
        .alerts-head {
          .manage-area {
            ${textTruncateSnippet}
            max-width: 100px;
          }
        }
      }
      .aside-wrapper {
        .nav-list {
          .item {
            .mt-c-6 {
              ${textTruncateSnippet}
              max-width: 45px;
            }
          }
        }
      }
      .group-badge {
          display: flex;
          flex-direction: column;
          align-items: center;
        p{
          ${textTruncateSnippet}
          max-width: 60px;
        }
      }
      .people-group-drawer {
        .groups-wrapper {
          .action-btn {
           ${textTruncateSnippet}
            max-width: 76px;
          }
        }
      }
      .person-item {
        .person-item-widget {
          .name-wrapper {
            h4 {
              ${textTruncateSnippet}
              max-width: 120px;
            }
          }
        }
      }
      .container-company-card {
        .founded-area {
          .item-label {
            ${textTruncateSnippet}
          }
        }
        .body-part {
          .state {
            ${textTruncateSnippet}
            width: 100%;
          }
        }
      }
      .states-average-score {
        h1 {
          ${textTruncateSnippet}
          width: 100%;
        }
      }
      .sign-out {
        .app-name {
          max-width: 130px;
          ${textTruncateSnippet}
        }
      }
      .toaster-content {
        .span-label {
          ${textTruncateSnippet}
          max-width: 40%;
        }
      }
      .download-doc {
        ul {
          li {
            ${textTruncateSnippet}
            width: 100%;
            display: list-item;
          }
        }
      }
      .company-card-bottom-area {
        .text-truncate-one-line{
          &.w-80 {
            width: 60%;
            min-width: 60%;
          }
        }
      }
      .ceo-tile {
        .person-item {
          .person-item-widget {
            margin: 20px 3px 0px 3px;
          }
        }
      }
      .tabSection {
        #tabs-details {
          h2 {
            font-size: 22px;
          }
        }
      }
      .highcharts-container  {
        .highcharts-legend-item {
          span[data-z-index="2"]{
            > {
              span {
                max-width: 160px;
                margin-top: 0px;
                line-height: 19px;
                ${textTruncateSnippet}
              }
            }
          }
        }
      }
      .body-profile {
        .other-side {
          .add-btn {
            margin: 0px 5px;
            display: inline-block;
            position: relative;
            top: -2px;
          }
          .share-article {
            margin: 0px 5px;
            position: relative;
            top: -1px;
          }
        }
      }
    }
  }
`;
export default GoogleTranslatorStyle;
